import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LockIcon from '@mui/icons-material/Lock';
import { useStyles } from './styles';
import useInAppGuide from './useInAppGuide';
import { imageWithPath, CommonImages } from '../../commons/images';

import usePageTransitions from '../../store/models/animations/usePageTransitions';
import {
    TransitionViewNames,
} from '../../store/models/animations/actions/transitions';
import { useAppStore } from '../../store/models/app';
import useKickstarted from '../../commons/hooks/useKickstarted';

const ecalLogoRound = imageWithPath(CommonImages.ECAL_INAPP_LOGO);
const ecalFooterLogo = imageWithPath(CommonImages.ECAL_BAR_LOGO);
const arrowTopImg = imageWithPath(CommonImages.INAPP_GUIDE_ARROW_TOP);
const arrowBottomImg = imageWithPath(CommonImages.INAPP_GUIDE_ARROW_BOTTOM);

function InAppGuide (props) {
    const {
        viewAnimation = false,
        initStyles = {},
    } = props;

    const classes = useStyles({
        viewAnimation,
        initStyles,
    });

    const appStore = useAppStore();

    const {
        arrow,
        action,
        title,
        showFooter,
        msg,
    } = useInAppGuide();

    usePageTransitions({
        elementName: TransitionViewNames.INAPP_GUIDE_VIEW,
        viewAnimation,
    });

    useKickstarted({
        onKickstarted: () => {},
    });

    if (!appStore.kickstarted) {
        return (<React.Fragment></React.Fragment>);
    }

    const positionText = arrow === 'top' ? 'above' : 'below';

    const renderMessage = () => {
        if (msg) {
            return (
                <Typography className={classes.description}>
                    {msg}
                </Typography>
            );
        }
        return (
            <Typography className={classes.description}>
                Please tap the Options Menu {positionText} and &apos;Open in {action}&apos; to continue.
            </Typography>
        );
    };

    const renderTopArrow = () => {
        if (arrow !== 'top') return null;
        return (
            <Box
                component="img"
                src={arrowTopImg}
                alt="Tap here"
                className={`${classes.arrowContainer} ${classes.topArrow}`}
            />
        );
    };

    const renderBottomArrow = () => {
        if (arrow !== 'bottom' && arrow !== 'bottom-center') return null;
        const positionClass = arrow === 'bottom-center' ? classes.bottomCenterArrow : classes.bottomArrow;
        return (
            <Box
                component="img"
                src={arrowBottomImg}
                alt="Tap here"
                className={`${classes.arrowContainer} ${positionClass}`}
            />
        );
    };

    return (
        <React.Fragment>
            <Grid
                id="content"
                name={TransitionViewNames.INAPP_GUIDE_VIEW}
                className={classes.container}
            >
                {renderTopArrow()}

                <Box className={classes.content}>
                    <Box
                        component="img"
                        src={ecalLogoRound}
                        alt="ECAL"
                        className={classes.logoImage}
                    />
                    <Typography className={classes.title}>
                        {title}
                    </Typography>
                    {renderMessage()}
                </Box>

                {showFooter && (
                    <Box className={classes.footer}>
                        <Typography className={classes.securityText}>
                            <LockIcon className={classes.lockIcon} />
                            A security message from
                        </Typography>
                        <Box
                            component="img"
                            src={ecalFooterLogo}
                            alt="ECAL"
                            className={classes.footerLogo}
                        />
                    </Box>
                )}

                {renderBottomArrow()}
            </Grid>
        </React.Fragment>
    );
}

InAppGuide.propTypes = {
    viewAnimation: PropTypes.bool,
    initStyles: PropTypes.any,
};

export default InAppGuide;
